import { InputAdornment, InputBase, styled } from '@mui/material';
import { SearchIcon, CloseIcon } from 'app/agriculture/icons';
import { primaryColourMain } from 'app/agriculture/material';
import { ChangeEvent, useRef, useState } from 'react';

const MediumOutlinedInputBase = styled(InputBase)({
    borderRadius: '8px',
    border: '1px solid rgba(0,0,0,0.2)',
    padding: '8px 24px',
    '&.Mui-focused': {
        border: `1px solid ${primaryColourMain}`,
        outline: `1px solid ${primaryColourMain}`,
    },
});

interface SearchFieldProps {
    textFilter: string;
    onChange: (filter: string) => void;
}

export function SearchField({ textFilter, onChange }: SearchFieldProps) {
    const [inputValue, setInputValue] = useState(textFilter);
    const ref = useRef<HTMLInputElement>(null);
    return (
        <MediumOutlinedInputBase
            inputRef={ref}
            id="search-input"
            className="SearchField"
            placeholder="Search"
            defaultValue={textFilter}
            onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
                onChange(e.target.value);
                setInputValue(e.target.value);
            }}
            fullWidth
            startAdornment={
                <InputAdornment position="start">
                    <SearchIcon color={primaryColourMain} size={20} />
                </InputAdornment>
            }
            endAdornment={
                inputValue.length > 0 && (
                    <InputAdornment
                        data-testid="search-input-close-icon"
                        position="end"
                        onClick={() => {
                            setInputValue('');
                            onChange('');
                            if (ref.current != null) {
                                ref.current.value = '';
                            }
                        }}
                        sx={{ cursor: 'pointer' }}
                    >
                        <CloseIcon color={primaryColourMain} size={14} />
                    </InputAdornment>
                )
            }
        />
    );
}
